module.exports = __webpack_public_path__ + "static/img/yyqy.7ba42b8d.png";